import React, {useCallback} from 'react';
import styled from 'styled-components';

interface ImageFieldProps {
    field: string;
    imageSrc: string;
    imageLabel?: string;
}

const ImageField = ({field, imageSrc, imageLabel}: ImageFieldProps) => {
    const onImageError = useCallback(
        (event: React.SyntheticEvent<HTMLImageElement>) => {
            const card = event?.currentTarget?.parentNode;
            // Target the image container so it won't mess up on the flex allocation
            const imageContainer = card?.parentNode;
            const parentElement = imageContainer?.parentNode;
            parentElement?.removeChild(imageContainer);
        },
        []
    );

    return (
        <Card data-cy={field}>
            <img className="card-image" src={imageSrc} onError={onImageError} />
            {imageLabel ? <span>{imageLabel}</span> : null}
        </Card>
    );
};

const Card = styled.div`
    padding: 5px 2px 0;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    margin: 3px 0 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 66px;

    & > img {
        width: 60px;
        height: 75px;
    }

    & > span {
        font-size: 7px;
        color: #918f8f;
    }
`;

export default ImageField;
